import { AccessType } from '@sonar-software/sonar-core';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';

import { Tag, Tooltip } from 'antd';

export type AccessTypeTagProps = {
    accessType: AccessType;
	disabled?: boolean;
};

export const accessTypeLabels: Record<AccessType, string> = {
	[ AccessType.Object ]: COPY_SPECIFIC.OBJECT,
	[ AccessType.PermissionSet ]: COPY_SPECIFIC.PERMISSION_SET,
	[ AccessType.Profile ]: COPY_SPECIFIC.PROFILE,
	[ AccessType.User ]: COPY_SPECIFIC.USER
};

const accessTypeColors: Record<AccessType, string> = {
	[ AccessType.Object ]: 'green',
	[ AccessType.PermissionSet ]: 'purple',
	[ AccessType.Profile ]: 'blue',
	[ AccessType.User ]: 'yellow'
};

export const AccessTypeTag: React.FC<AccessTypeTagProps> = ({ accessType, disabled }) =>
	<Tooltip
		placement='bottom'
		title={ `${COPY_SPECIFIC.INACTIVE} ${accessTypeLabels[ accessType ]}` }
		trigger={ disabled ? undefined : [] }>
		<Tag
			className={ classNames('access-type-tag', { disabled }) }
			color={ accessTypeColors[ accessType ] }>
			{ accessTypeLabels[ accessType ] }
		</Tag>
	</Tooltip>;
